// extracted by mini-css-extract-plugin
export default {"checkbox-button":"styles_checkbox-button__LfUjz","checkbox-label":"styles_checkbox-label__E8Xxs"};